module.exports = __webpack_public_path__ + "img/RedteaSIM_05.487a22e1.png";